import React, { useState } from 'react';
import { BygrUserDetails, BygrUserProjectMembership } from '@/types';
import { createDataTable } from '@/components/DataTable';
import { showModules } from '@/utils/util';
import { CustomLink } from '@ygtechnologies/bygr-frontend-component-library';

export interface UserProjectsProps {
    user: BygrUserDetails;
    reload(): void;
}
const MemberDataTable = createDataTable<BygrUserProjectMembership>();

export const UserProjects: React.FC<UserProjectsProps> = ({ user }) => {
    const [memberTableState, setMemberTableState] = useState(MemberDataTable.getInitialState('profileId'));

    // const a = groupBy(user.projectMemberships, 'profileId');

    // return (
    //     <div>
    //         {Object.entries(a).map([profileId, items] => )}

    //     </div>
    // )

    return (
        <MemberDataTable
            hasPagination={false}
            data={user.projectMemberships}
            onStateChange={setMemberTableState}
            state={memberTableState}
            totalItemCount={user.projectMemberships.length}
            className="table style-3">
            <MemberDataTable.Column header="Project Id" field="projectId" renderer={({ value }) => value} />
            <MemberDataTable.Column header="Project Name" field="projectName" renderer={({ value, row }) => <CustomLink to={`/projects/${row.projectId}`}>{value}</CustomLink>} />
            <MemberDataTable.Column header="Profile" field="profileName" renderer={({ value, row }) => <CustomLink to={`/profiles/${row.profileId}`}>{value}</CustomLink>} />
            <MemberDataTable.Column header="Module" field="bygrModules" renderer={({ value }) => showModules(value)} />
            {/* <MemberDataTable.Column header="Module" field="bygrModules" renderer={({ value }) => showModules(value)} /> */}
        </MemberDataTable>
    );
};